/**
 * @module TestDetailDefaults
 * @description Phase 17 extraction of TestDetailPanel default values, breadcrumb targets, and title helpers.
 * Centralizes shared, VoIP, and Web create/copy defaults used by the detail page assembler.
 */

import { isEmpty } from 'lodash';

import { NAME_FIELD } from '../../infrastructure/InfrastructureConstants';
import { DEFAULT, PARENT_TITLE, TYPE_VOIP } from '../ServiceTestsConstants';
import {
    DEFAULT_JITTER,
    SCHEDULED_CALL_DURATION_OPTIONS,
    SCHEDULED_RING_DURATION_OPTIONS,
} from '../../../panels/voip-test-now-panels/VoipTestConstants';
import { GET_METHOD } from '../../../panels/web-test-now-panels/WebTestConstants';

export const GOTO_GRANDPARENT_TYPE_URL = '../../../';
export const GOTO_PARENT_TYPE_URL = '../';
export const BASE_URL = '/ngp/v2/service-tests/';
export const GRANDPARENT_FUNCTION_BREADCRUMBS = { text: PARENT_TITLE, link: GOTO_GRANDPARENT_TYPE_URL };

export const DEFAULT_VALUES = {
    [NAME_FIELD]: '',
    status: 'Running',
    agents: { all: true },
    tags: [],
    bttUser: { bttUserDefaultLogin: true },
    adapterType: DEFAULT,
    scheduling: {},
};

// Default codec selection — matches portal/ui NO_PREF = { '*': 'No Preference' }
export const NO_PREF_CODEC_KEY = '*';

// portal/ui default HTTP Response Code (webTestConfig.directive.js:76)
export const DEFAULT_RESPONSE_CODE = '200';

// VoIP Create-mode defaults — mirrors portal/ui controller init
// (voipPulseToPhoneConfig.controller.js:61-64, voipPulseTestConfig.directive.js:345-347)
export const VOIP_DEFAULT_VALUES = {
    ...DEFAULT_VALUES,
    testConfig: {
        ringDuration: SCHEDULED_RING_DURATION_OPTIONS[0],
        duration: SCHEDULED_CALL_DURATION_OPTIONS[0],
        preferredCodec: NO_PREF_CODEC_KEY,
        jitter: DEFAULT_JITTER,
    },
};

// Web Create-mode defaults — mirrors portal/ui webTestConfig.directive.js:61,76
export const WEB_DEFAULT_VALUES = {
    ...DEFAULT_VALUES,
    testConfig: {
        method: GET_METHOD,
        responseCode: DEFAULT_RESPONSE_CODE,
    },
};

export const target = 'test-detail';
export const filterId = 'Test';

export const getTestTypeTitle = (testType, group) => {
    if (isEmpty(group)) {
        return '';
    }

    if (TYPE_VOIP === group) {
        return group;
    }

    if (isEmpty(testType)) {
        return group;
    }

    return testType?.details?.title || group;
};
